import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'refetch': {
        reExecuteQuery({ requestPolicy: 'network-only' })
        return
      }

      case 'create_automations': {
        setFlowTo(
          normalizePath(props.viewPath, 'Content/SetupAction/Content/Content')
        )
        return
      }

      default: {
        return
      }
    }
  }
}
